import React, { useState, useEffect } from "react";
import './HRSourceFile.css';
import { Upload, message, Spin, Button, Modal, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { DeleteOutlined, UploadOutlined, ReloadOutlined } from "@ant-design/icons";
import { BaseUrl, JsonConfig, FormConfig, UserName } from "../../Repository/BaseRepository";
import HealthInsuranceTable from "../HealthInsuranceTable/HealthInsuranceTable";
import { ErrorMessage, SuccessMessage } from "../../Utils/Utils";
import { callGetGridData, csvDownloadHRGridData } from "../../Repository/HealthInsuranceRepository";
import axios from "axios";

const HRSourceFile = () => {

    const [hrSourceFile, setHrSourceFile] = useState([]);
    const [spin, setSpin] = useState(false)
    const [csvDownloadSpin, setCsvDownloadSpin] = useState(false)
    const [hrUploader, setHrUploader] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [gridData, setTableGridData] = useState([]);
    const [disableSync, setDisableSync] = useState(false)
    const [nodataMsg, setNodataMsg] = useState([])
    const [syncSpin, setSyncSpin] = useState(false)
    const [tableSpin, setTableSpin] = useState(false)
    var temp = 0;
    useEffect(() => {
        if (temp === 0) {
            temp = 1;
            settingTableSpinner();
        }
    }, [])

    const handleUpload = async (options) => {
        try {
            setSpin(true)
            const { file, onSuccess, onError } = options;
            const updatedDeductionFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("HealthInsuranceFile", file);
            setHrSourceFile([])
            setHrUploader(file.name);
            const response = await axios.post(`${BaseUrl}HealthInsurance/postIsuranceInputData?uName=${UserName}`, formData, FormConfig)
            if (response.data.statusCode === 200) {
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedDeductionFile.status = "done"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
            else if(response.data.statusCode === 400){
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
            else {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setHrUploader('')
            setSpin(false)
        }
    }
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (hrSourceFile.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ display: "flex" }}>
                <div style={{ color: statusColor, display: "flex", borderRadius: "4px" }}>{fileExists ?
                    <div>{hrSourceFile[0].file.name} </div> : null}</div>
                <DeleteOutlined onClick={() => setHrSourceFile([])} />
            </div>
        </>;
    };
    const settingTableSpinner = async () => {
        setTableSpin(true)
        const res = await callGetGridData()
        if (res !== null && res.length > 0) {
            setTableGridData(res)
            setDisableSync(true)
        }
        setTableSpin(false)
    }

    const callDataSync = async () => {
        try {
            setSyncSpin(true)
            let url = `${BaseUrl}HealthInsurance/postInsuranceOutputData`
            const data = [];
            const response = await axios.post(url, data, JsonConfig)
            if (response.data.statusCode === 200) {
                const res = await callGetGridData()
                if (res !== null && res.length > 0) {
                    setTableGridData(res)
                    setDisableSync(true)
                }
                else {
                    setTableGridData([])
                }
                setSyncSpin(false)
            }
            else if (response.data.statusCode === 500) {
                setNodataMsg(response.data.message)
                setOpenModal(true)
                setSyncSpin(false)
            }
        }
        catch (err) {
            ErrorMessage("Cannot able to fetch data, please try again");
            setSyncSpin(false)
        }
    }
    const downloadDataCSV = async () => {
        setCsvDownloadSpin(true)
        const resp = await csvDownloadHRGridData(gridData)
        if (resp === "downloaded") {
            SuccessMessage("Downloaded successfully !!")
        }
        setCsvDownloadSpin(false)
    }

    return (<>
        <div className="whole-hrsource">
            <div className="source-file-uploader">
                <div className="upload-sync">
                    <div className="sourcefile-upload">
                        <div className="file-upload" style={{ height: "39px", width: "90%", borderRadius: "10px" }}>
                            <Upload.Dragger
                                name="file"
                                customRequest={handleUpload}
                                itemRender={itemRender}
                                fileList={hrSourceFile}
                                accept=".xls,.xlsx"
                                onRemove={() => setHrSourceFile([])}
                                style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}
                            >
                                <div className='content-file'>
                                    <span>Upload File</span>
                                    <UploadOutlined style={{ fontSize: 17 }} />
                                </div>
                            </Upload.Dragger>
                            {hrUploader.length > 0 ? <div style={{marginBottom:2, color:"rgba(0, 39, 102, 1)"}}>{hrUploader}</div> : null}
                        </div>
                        <div className="xl-spinner" >
                            {spin ? <Spin size="medium" style={{marginRight:'5px'}}/> : null}
                        </div>
                    </div>
                    <div className="sourcefile-upload">
                        <div className="paychex-upload">
                            {/* <div className="paychex-upload-button"> */}
                                <Link to={{ pathname: "/utilities", state: { redirectedUrl: "healthinsurance" } }} className="link-class">Upload Active List <UploadOutlined style={{ fontSize: 17 }} /></Link>
                            {/* </div> */}
                        </div>
                    </div>
                    <div className="sync-button-class">
                        <Button className={disableSync ? "sync-button" : "sync-button-enable"} onClick={callDataSync} disabled={disableSync}>Sync Data
                            {syncSpin ? <Spin indicator={<ReloadOutlined className="spin-indicatior" style={{ fontSize: 16, marginLeft: 7 }} spin />} /> : <ReloadOutlined />}
                        </Button>
                        <Modal open={openModal} footer={false} onCancel={() => setOpenModal(false)}>{nodataMsg}</Modal>
                    </div>
                </div>
                <div className="csv-dwn-class">
                    <Button className="download-csv" onClick={downloadDataCSV} loading={csvDownloadSpin}>Download .CSV
                        {csvDownloadSpin ? null : <UploadOutlined style={{ transform: "rotate(180deg)", marginLeft: 15, fontSize: 19 }} />}
                    </Button>
                </div>
            </div>
            <div className="hrfile-table-class">
                <HealthInsuranceTable grid={gridData} tSpin={tableSpin} sendDataToParent={setTableGridData} />
            </div>
        </div>
    </>)
}

export default HRSourceFile;